export const Temas = {
    DEFAULT: {
      style:{__html: `
                      body { 
                        margin: 0; 
                        position: relative; 
                        background: url("` + process.env.PUBLIC_URL + `/img/bg_header.jpg") repeat-x #fff !important; 
                        background-size: 100% 120px; 
                      } 
                      @media screen and (max-width: 544px) { 
                        body{ 
                          background-size: 100% 65px !important; 
                        } 
                      } 
                      `},
                      
      showPaper:false,
      showMenu:true,
      showHeader:true,
      showFooter:true,
      container:'container-fluid',
      bodyId:'corpo',
      bodyClass:''
    },
    DEFAULT_WITHOUT_PAPER: {
      style:{__html: `body {  
                        margin: 0;
                        position: relative;
                        background: url("`+process.env.PUBLIC_URL+`/img/bg_fundo.jpg") no-repeat #018230 !important;
                      }`},
      showPaper:false,
      showMenu:true,
      showHeader:true,
      showFooter:true,
      container:'container-fluid',
      bodyId:'corpo',
      bodyClass:''
    },
    CLEAR: {
      style:{__html: `body {  
                        margin: 0;
                        position: relative;
                        background: url("`+process.env.PUBLIC_URL+`/img/bg_fundo.jpg") no-repeat #018230 !important;
                      }`},
      showPaper:false,
      showMenu:true,
      showHeader:true,
      showFooter:false,
      container:'container-fluid',
      bodyId:'corpo',
      bodyClass:''
    },
    BLANK: {
      style:{__html: `body{ 
                        background: url("`+process.env.PUBLIC_URL+`/img/bg.jpg") center #FFF !important; background-position: center right;
                      }`},
      showPaper:false,
      showMenu:false,
      showHeader:false,
      showFooter:false,
      container:'container h-100',
      bodyId:'',
      bodyClass:''
    }
};